const step_up = {
    verify_your_identity: 'Zweryfikuj swoją tożsamość',
    choose_method_description: 'Aby kontynuować, potwierdź swoją tożsamość za pomocą jednej z poniższych metod.',
    password: 'Hasło',
    password_description: 'Wprowadź hasło do swojego konta',
    enter_password_description: 'Wprowadź hasło do swojego konta, aby kontynuować.',
    enter_verification_code_description: 'Wprowadź kod weryfikacyjny wysłany na {{identifier}}.',
    subject_proof_description: 'Aby kontynuować, potwierdź swoją tożsamość za pomocą konta powiązanego z Twoim. Następnie możesz skonfigurować metodę weryfikacji.',
    no_method_available: 'Brak dostępnej metody weryfikacji',
    no_method_available_description: 'Twoje konto nie ma metody, która mogłaby ukończyć tę weryfikację. Skontaktuj się z administratorem, aby uzyskać pomoc.',
};
export default Object.freeze(step_up);
